


























































import { Component, Prop, Provide, Vue } from "vue-property-decorator";

@Component
export default class headerPage extends Vue {
	public isShow: Boolean = false;
 	// 移入
    mouseOver() {
		this.isShow = true;
    }
    // 移出
    mouseLeave() {
      	this.isShow = false;
    }
}
